import React, { FC, ReactNode, useContext, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router';
import redirectTo from '../../utils/redirectTo';
import { validateAvailability } from '../../utils/validateAvailability';
import ApplicationAvailabilityContext from './ApplicationAvailabilityContext';

export interface ApplicationAvailabilityProps {
  group: string;
  company: '0' | '6';
  experience: 'CLIENT' | 'ADVISOR' | 'EMPLOYEE';
  unavailablePageUrl: string;
  publicRoute: boolean;
  loading: ReactNode;
  children: ReactNode;
}

export const localStorageBypassKey = 'bypass-availability';

const ApplicationAvailability: FC<ApplicationAvailabilityProps> = ({ group, company, experience, unavailablePageUrl, publicRoute, loading, children }) => {
  const [error, setError] = useState(false);
  const history = useHistory();
  const ctx = useContext(ApplicationAvailabilityContext);
  const localStorageValue = localStorage.getItem(localStorageBypassKey);
  const isAvailable = useMemo(
    () =>
      localStorageValue === 'true' ||
      (ctx.availability && (ctx.availability?.isAvailable === true || ctx.availability?.isAuthorizedDuringMaintenance === true)),
    [ctx.availability, localStorageValue],
  );

  useEffect(() => {
    if (!ctx.availability) {
      validateAvailability(group, company, experience, publicRoute)
        .then((availability) => ctx.saveAvailability(availability))
        .catch(() => setError(true));
    }
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  if (!ctx.availability) {
    return (
      <>{error ? children : loading}</>
    );
  }
  if (!isAvailable) redirectTo(unavailablePageUrl, history);

  return (
    <>{children}</>
  );
};

export default ApplicationAvailability;
